var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D5E1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.6667C17.5 13.9614 17.3829 14.244 17.1746 14.4523C16.9662 14.6607 16.6836 14.7778 16.3889 14.7778H9.72222L7.5 17V8.11111C7.5 7.81643 7.61706 7.53381 7.82544 7.32544C8.03381 7.11706 8.31643 7 8.61111 7H16.3889C16.6836 7 16.9662 7.11706 17.1746 7.32544C17.3829 7.53381 17.5 7.81643 17.5 8.11111V13.6667Z",
    stroke: "#103D9E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquare);
export default __webpack_public_path__ + "static/media/message-square.558acecc7aaed127f8dbe4dc8c0680f2.svg";
export { ForwardRef as ReactComponent };